module.exports = __webpack_public_path__ + "static/media/10.064abdd4.gif";